import { render, staticRenderFns } from "./PurchaseInvoicesTable.vue?vue&type=template&id=f5c14164&"
import script from "./PurchaseInvoicesTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports